<template>
  <modal
    :show-modal="showModal"
    @close-modal="closeModal"
    width="35"
    title="Add New Reference"
  >
    <div class="flex flex-col gap-4">
      <p class="border-b border-dashed pb-2">Add references that you can use when setting up DNS for entities</p>
      <h3 class="font-semibold mb-2">Reference Details</h3>
      <h3 class="font-semibold mb-2">Reference </h3>
      <el-select v-model="reference">
        <el-option value="dd" text="ndn"></el-option>
      </el-select>
      <h3 class="font-semibold mb-2"> Application </h3>
      <el-select v-model="reference">
        <el-option value="dd" text="ndn"></el-option>
      </el-select>
      <div class="flex flex-col gap-0 pl-2">
      <label for="" >Max. Character Length</label>
      <div class="flex gap-2">
          <input type="number" class="border rounded border-gray-500 p-2 w-24" id="">
          <span class="bg-gray-100 rounded-sm p-2">Example: ---</span>
        </div>
      </div>
      <hr class="border-dashed">
      <base-button class="ml-auto" text="Save" />
    </div>
  </modal>
</template>

<script>
export default {
  props: ["showModal"],
  data(){
    return {
      reference: ""
    }
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
  },
};
</script>

<style> 
hr {
  border: 1px dashed #b7bdcd;
}
.entity-name {
  background: #dae8f6;
  padding: 0.5em;
  text-align: center;
}
</style>